import {
  Navigation,
  RequiredDashboardData,
} from "@nju/feature-portal-dashboard";
import { Footer } from "@nju/feature-portal-footer";
import { Header } from "@nju/feature-portal-header";
import {
  DashboardPaymentSubmenu,
  InvoiceHistoryPage,
} from "@nju/feature-portal-payment";
import { BlockContent, LayoutWrapper } from "@nju/ui";

export default function DashboardPaymentHistory() {
  return (
    <LayoutWrapper>
      <Header />
      <BlockContent grid="narrow" spacing="xl" tone="primary">
        <RequiredDashboardData extendedMode="base">
          <Navigation title="płatności" />
          <DashboardPaymentSubmenu />
          <InvoiceHistoryPage />
        </RequiredDashboardData>
      </BlockContent>
      <Footer />
    </LayoutWrapper>
  );
}
